module.exports = __webpack_public_path__ + "img/swbg.35142e5b.svg";